module.exports = new __parcel__URL__("2.5f2e0f39.png").toString();